import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { useHistory } from "react-router-dom";
import theme from '../../components/shared/theme';
import { ThemeProvider } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from '@material-ui/core/DialogActions';
import ClearIcon from '@material-ui/icons/Clear';
import api from '../../store/api';
import { TextField, Select, MenuItem } from '@material-ui/core';
import LinearProgress from "@material-ui/core/LinearProgress";
import { error } from "console";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";



const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        paper: {
            padding: theme.spacing(0),
            textAlign: 'center',
            color: theme.palette.text.secondary,
        },
        loading: {
            width: "100%",
        },
        formControlLabel: {
            fontSize: 18,
            color: '#4A4A4A',
            padding: theme.spacing(0, 0, 1, 0)

        },
        container: {
            backgroundColor: '#00152e',
            backgroundSize: '100%',
            borderRadius: '0',
            width: '100%',
            padding: 60,
        },
        button: {
            width: '100%',
        },
        selectField: {
            height: 40,
        },
        dialogPaper: {
            minWidth: 500,
            margin: 0,
            borderRadius: 0,
            shadow: 'none',
            backgroundColor: '#fff',
        },
        header: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 30,
        },
        modalTitle: {
            fontSize: 19,
            color: '#03090E',
        },
        helpText: {
            color: 'red',
            padding: theme.spacing(0, 0, 0, 2)
        },
        dropdownIcon: {
            top: 4
        }
    }),
);

const CreateLoadingLine = (props: any): JSX.Element => {
    const classes = useStyles();
    return (
        <div className={classes.loading} style={props.show ? { display: "" } : { visibility: "hidden" }}>
            <LinearProgress color="primary" />
        </div>
    );
};

const ReasonForCancellationModal = (props: any) => {
    const classes = useStyles();
    const { open, onClose, setTransferLoadingData, transferLoadingData, transferId, fromTransfer, currentTripPlannerId, smaUser, locationId } = props;
    const [isLoading, setIsLoading] = React.useState(false);
    const [reasons, setreasons] = React.useState([]);
    const { handleSubmit, watch, formState, getValues, setError, control, setValue, errors, trigger } = useForm();

    const onCloseLocal = () => {
        onClose();
    }

    const cancelTransfer = async (data: any) => {
        const isValid = await trigger();
        if (isValid) {
            setIsLoading(true);
            let transferdata = {
                transferid: transferId,
                reasonforcancellationid: data.reason,
                reasonForCancellationNote: data.ReasonNote
            };
            await api
                .cancelTransfer(``, transferdata)
                .then(async (result: any) => {
                    if (!result.hasError) {
                        await checkTransferState(transferId);
                        setIsLoading(false);
                        onCloseLocal();
                    }
                    setIsLoading(false);
                })
                .catch((error) => {
                    setIsLoading(false);
                });
        }
    };


    const checkTransferState = async (transId: string): Promise<void> => {
        setIsLoading(true);
        try {
            const res = await api.getTransferState(`transferId=${transId}`);
            if (!res.data.errorRaised) {
                let updateData = {
                    status: res.data.model.status,
                    assignedVehicle: res.data.model.assignedVehicle,
                    priority: res.data.model.priority,
                    scheduledDate: res.data.model.scheduledDate,
                };
                setTransferLoadingData({ ...transferLoadingData, ...updateData });
                setIsLoading(false);
            }
        } catch (err) {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        GetCancelTransferReasons();
      }, []);

    const GetCancelTransferReasons = async (): Promise<void> => {
        setIsLoading(true);
        try {
            const res = await api.getReasonsForCancellationPerUser(``);
            if (!res.data.errorRaised) {
                const _reason = res.data.model;
                setreasons(_reason);
                setIsLoading(false);
            }
        } catch (err) {
            setIsLoading(false);
        }
    };

    //console.log(errors);

    return (
        <ThemeProvider theme={theme}>
            <Dialog classes={{ paper: classes.dialogPaper }} maxWidth="sm" open={open} onClose={onCloseLocal} aria-labelledby="form-dialog-title">
                <ThemeProvider theme={theme}>
                    {isLoading ? <CreateLoadingLine show={isLoading} /> : null}

                    <form onSubmit={handleSubmit(cancelTransfer)}
                        autoComplete="off"
                        id="CancellationForm">

                        <DialogContent>
                            <div className={classes.header}>
                                <div className={classes.modalTitle}>Cancel Transfer</div>
                                <ClearIcon onClick={onCloseLocal} style={{ cursor: "pointer", }} />
                            </div>
                            <Grid item xs={12}>
                                <div className={classes.formControlLabel}>Reason</div>
                                <Controller
                                    name="reason"
                                    defaultValue=""
                                    control={control}
                                    render={({ onChange, onBlur, value, name }) => (
                                        <Select
                                            onChange={(e) => {
                                                onChange(e);
                                            }}
                                            value={value}
                                            error={errors.reason}
                                            className={classes.selectField}
                                            displayEmpty
                                            IconComponent={KeyboardArrowDownIcon}
                                            defaultValue=""
                                            fullWidth={true}
                                            variant="outlined"
                                        >
                                            <MenuItem key="None" value={""}>
                                                Choose Reason
                                            </MenuItem>
                                            {reasons !== undefined && reasons.length>0 ?
                                            reasons.map((res: any) => {
                                                return (
                                                    <MenuItem selected={res.reasonForCancellationId} key={res.reasonForCancellationId} value={res.reasonForCancellationId}>
                                                        {res.name}
                                                    </MenuItem>
                                                );
                                            })
                                            :null}
                                        </Select>
                                    )}
                                    rules={{
                                        required: "Reason is required",
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <div className={classes.formControlLabel}>Notes</div>
                                <Controller
                                    name='ReasonNote'
                                    defaultValue=''
                                    
                                    control={control}
                                    as={
                                        <TextField
                                            variant='outlined'
                                            multiline
                                            rows={5}
                                            error={errors.ReasonNote}
                                            helperText={errors.ReasonNote ? errors.ReasonNote.message : ""}
                                            InputProps={{
                                                style: {
                                                    height: 110,
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    justifyContent: 'flex-start',  
                                                },
                                                //maxLength: 10,
                                            }}
                                            // inputProps={{
                                            //     maxLength: 25,
                                            //   }}
                                        />}
                                    rules={{
                                        required: {
                                            value: true,
                                            message: "Notes is required"
                                        },
                                    }}
                                />
                            </Grid>
                        </DialogContent>

                        <DialogActions>
                            <Grid container spacing={3} style={{ marginBottom: 10 }}>
                                <Grid item xs={6}>
                                    <Button className={classes.button} onClick={onCloseLocal} style={{ fontWeight: 'bold', backgroundColor: '#ECECEC', color: '#090F15' }} color="primary">
                                        Cancel
                                    </Button>
                                </Grid>
                                <Grid item xs={6}>
                                    <Button className={classes.button} disabled={formState.isSubmitting}
                                        type='submit' style={{ fontWeight: 'bold' }} color="primary">
                                        Cancel Transfer
                                    </Button>
                                </Grid>
                            </Grid>
                        </DialogActions>
                    </form>
                </ThemeProvider>
            </Dialog>
        </ThemeProvider>
    );
}


export default ReasonForCancellationModal;